import { render, staticRenderFns } from "./Mantras.vue?vue&type=template&id=5f2b3708"
import script from "./Mantras.vue?vue&type=script&lang=js"
export * from "./Mantras.vue?vue&type=script&lang=js"
import style0 from "./Mantras.vue?vue&type=style&index=0&id=5f2b3708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports